import { useEffect } from 'react';
import { IconClose } from './icons';

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
  readonly id: string;
  readonly kind: ToastKind;
  readonly message: string;
  /** Errors stay until dismissed; successes fade. */
  readonly sticky?: boolean;
}

interface Props {
  readonly toasts: readonly Toast[];
  readonly onDismiss: (id: string) => void;
}

function ToastRow({ toast, onDismiss }: { toast: Toast; onDismiss: (id: string) => void }) {
  useEffect(() => {
    if (toast.sticky) return undefined;
    const timer = setTimeout(() => onDismiss(toast.id), 4200);
    return () => clearTimeout(timer);
  }, [toast, onDismiss]);

  return (
    <div className={`toast ${toast.kind}`}>
      <span style={{ flex: '1 1 auto' }}>{toast.message}</span>
      <button
        type="button"
        className="close"
        onClick={() => onDismiss(toast.id)}
        aria-label="Dismiss notification"
      >
        <IconClose />
      </button>
    </div>
  );
}

export function Toasts({ toasts, onDismiss }: Props) {
  return (
    <div className="toasts" role="region" aria-label="Notifications">
      {toasts.map((toast) => (
        <ToastRow key={toast.id} toast={toast} onDismiss={onDismiss} />
      ))}
    </div>
  );
}
